import { useCallback, useMemo, useState } from "react";
import { useSnackbar } from "~/Provider/Snackbar";

const useAsyncAction = <T = unknown,>(
    action: (params?: any) => Promise<T>,
) => {
    const snackbar = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [data, setData] = useState<T | null>(null);

    const run = useCallback((args?: any) => {
        if (isLoading) return;

        setIsLoading(true);
        setIsError(false);
        setError(null);

        action(args)
            .then((res) => {
                setData(res);
            })
            .catch((err) => {
                snackbar.error(err);
                setError(err);
                setIsError(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [action, isLoading, snackbar]);

    return useMemo(
        () => ({
            data,
            isLoading,
            isError,
            error,
            run,
        }),
        [data, error, isError, isLoading, run]
    );
};

export default useAsyncAction;
